"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../types");
const web_ui_1 = require("@gibme/web-ui");
const common_1 = require("../common");
const api_1 = __importDefault(require("../api"));
const provide_mobile_1 = __importDefault(require("./provide_mobile"));
const show_verify_otp_modal = (record, login = true) => {
    web_ui_1.ModalHelper.once('shown', () => {
        const otp_field = web_ui_1.ModalHelper.select('#sms_otp');
        otp_field.on('keyup change', event => {
            const target = (0, web_ui_1.$)(event.target);
            (0, common_1.checkOTP)(target);
        });
        web_ui_1.ModalHelper.select('#otp_verify_button').on('click', () => __awaiter(void 0, void 0, void 0, function* () {
            if (otp_field.hasClass('is-invalid')) {
                return;
            }
            const otp = otp_field.val() || '';
            if (otp.length === 0) {
                return;
            }
            try {
                web_ui_1.LoadingOverlay.show();
                if (!login) {
                    const status = yield api_1.default.clientRegister(Object.assign(Object.assign({}, record), { otp }));
                    if (status === types_1.HTTPError.OK) {
                        web_ui_1.LoadingOverlay.hide();
                        return web_ui_1.StatusModal.show({
                            title: 'Mobile Phone Number Successfully Registered',
                            body: 'Thank you! Your phone number has been successfully registered.' +
                                ' Please continue logging in.'
                        });
                    }
                }
                else {
                    const [result, info] = yield api_1.default.clientLogin(Object.assign(Object.assign({}, record), { otp }));
                    if (result === types_1.HTTPError.OK && info) {
                        (0, web_ui_1.$)('#client_name').text(`${info.first_name} ${info.last_name}`);
                        (0, web_ui_1.$)('#client_dob').val('');
                        (0, web_ui_1.$)('#client_secret').val('');
                        web_ui_1.ModalHelper.close();
                        return (0, common_1.swapCard)((0, web_ui_1.$)('#client-login-card'), (0, web_ui_1.$)('#client-portal-card'));
                    }
                    else if (result === types_1.HTTPError.MOBILE_REQUIRED) {
                        web_ui_1.LoadingOverlay.hide();
                        return (0, provide_mobile_1.default)(record);
                    }
                    else if (result === types_1.HTTPError.OTP_REQUIRED) {
                        web_ui_1.LoadingOverlay.hide();
                        return show_verify_otp_modal(record);
                    }
                }
                web_ui_1.LoadingOverlay.hide();
                return web_ui_1.StatusModal.show({
                    title: 'An Error Occurred!',
                    body: 'An error occurred! Please try again!'
                });
            }
            catch (_a) {
                web_ui_1.LoadingOverlay.hide();
                return web_ui_1.StatusModal.show({
                    title: 'An Error Occurred!',
                    body: 'An error occurred! Please try again!'
                });
            }
        }));
    });
    web_ui_1.ModalHelper.open({
        title: 'Verify Mobile Number',
        body: (0, web_ui_1.$)('#verify_sms_modal').clone()
            .removeClass('d-none')
    });
};
exports.default = show_verify_otp_modal;
